


<header>
  <!-- navbar start -->
  <!-- navbar start -->
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand ml-5 d-lg-block d-none" routerLink="/home"><img src="/assets/About/image/logo.svg" alt="Logo" /></a>
      <a class="navbar-brand ml-5 d-lg-none d-block" routerLink="/home"><img src="/assets/Learning-center/image/logo1.svg" alt="Logo" /></a>
      <button class="navbar-toggler navbar-light" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page"  routerLink="/coverage">Coverage</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/learningCenter">Learning Center</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  routerLink="/about">About </a>
          </li>
        </ul>
      </div>

      <ul class="navbar-nav last-navbar ml-lg-auto ml-0 mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link btn btn-orange" href="#">Get a quota</a>
        </li>
        <li class="nav-item user">
          <a class="nav-link" href="#"> <i class="far fa-user"></i> </a>
        </li>
      </ul>
    </div>
  </nav>

  <!-- navbar end -->

  <!-- hero area start -->
  <section class="hero-area">
    <div class="container">
      <div class="hero-body">
        <div class="row">
          <div class="col-lg-6 col-md-8 col-sm-10">
            <p>Insurance Guide</p>
            <h1>Homeowners Association Insurance Basics</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- hero area end -->
</header>
<!------------------------- header end ------------------------------>
<!------------------------- guide start ------------------------------>
<section class="guide">
  <div class="container">
    <div class="row">
      <div class="col-6">
        <h2 class="section-header">Insurance Guides</h2>
      </div>
      <div class="col-6">
        <p class="text-right">
          <a href="#" class="expert-btn">View All</a>
        </p>
      </div>
    </div>


    <hr>

    <div class="guide-body">
      <div class="row">
        <div class="col-md-4 col-sm-6">
          <div class="card">
            <img src="/assets/Learning-center/image/learning-card1.jpg" class="card-img-top" alt="photo">
            <div class="card-body">
              <h3 class="card-title my-4">Homeowners Association Insurance Basics</h3>
              <p class="card-text">A must-read for HOA Board members</p>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div class="card">
            <img src="/assets/Learning-center/image/learning-card2.jpg" class="card-img-top" alt="photo">
            <div class="card-body">
              <h3 class="card-title my-4">Everything You Need to Know About Directors & Officers Insurance</h3>
              <p class="card-text">A must-read for HOA Board members</p>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div class="card">
            <img src="/assets/Learning-center/image/learning-card3.jpg" class="card-img-top" alt="photo">
            <div class="card-body">
              <h3 class="card-title my-4">7 Ways to Keep HOA Insurance Costs Down</h3>
              <p class="card-text">A must-read for HOA Board members</p>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div class="card">
            <img src="/assets/Learning-center/image/learning-card4.jpg" class="card-img-top" alt="photo">
            <div class="card-body">
              <h3 class="card-title my-4">Homeowners Association Insurance Basics</h3>
              <p class="card-text">A must-read for HOA Board members</p>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div class="card">
            <img src="/assets/Learning-center/image/learning-card5.jpg" class="card-img-top" alt="photo">
            <div class="card-body">
              <h3 class="card-title my-4">7 Ways to Keep HOA Insurance Costs Down</h3>
              <p class="card-text">A must-read for HOA Board members</p>

            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div class="card">
            <img src="/assets/Learning-center/image/learning-card6.jpg" class="card-img-top" alt="photo">
            <div class="card-body">
              <h3 class="card-title my-4">Everything You Need to Know About Directors & Officers Insurance</h3>
              <p class="card-text">A must-read for HOA Board members</p>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
<!------------------------- guide end ------------------------------>


<!-----------------------  expert start ----------------------->
<section class="expert">
  <div class="container">

    <div class="row ">
      <div class="col-12 pb-5 d-md-block d-none">
        <div class="row">
          <div class="col-6">
            <h2 class="section-header">Ask The Expert</h2>
          </div>
          <div class="col-6 p-0">
            <p class="text-right">
              <a href="#" class="expert-btn">View All</a>
              <span class="expert-src"><i class="fas fa-search"></i>
                <span class="expert-src-inp"><input type="text" name="" id=""><a href="#" class="expert-src d-inline ml-2 p-2"><i class="fas fa-search"></i> </a>
                </span></span>
            </p>
          </div>
        </div>
        <hr class="mb-5">
      </div>
      <div class="col-lg-5 col-md-6 mr-lg-auto expert-left">
        <h1 class="text-md-left text-center">Answers to All of Your Real Estate Insurance Questions</h1>
        <div class="ex-user mt-5">
          <img src="/assets/Learning-center/image/Ellipse2.png" alt="Photo">
          <span>
                                <p class="pt-5"><b>Manny Rios </b></p>
                                <p>Chief Underwiriting Officer</p>
                            </span>
        </div>
      </div>
      <div class="col-12 pb-5 d-md-none d-block">
        <div class="row">
          <div class="col-6">
            <h2 class="section-header">Ask The Expert</h2>
          </div>
          <div class="col-6">
            <p class="text-right">
              <a href="#" class="expert-btn">View All</a>
              <span class="expert-src"><i class="fas fa-search"></i>
                                        <span class="expert-src-inp"><input type="text" name="" id=""><a href="#" class="expert-src d-inline ml-2 p-2"><i class="fas fa-search"></i> </a>
                                        </span></span>
            </p>
          </div>
        </div>
        <hr class="mb-5">
      </div>
      <div class="col-lg-6 col-md-6 expert-right">
        <div class="qna">
          <h2>When Should Condo or Homeowner Association Boards Typically Start Thinking About Renewing Insurance?</h2>
          <a href="#">Category Name</a>
        </div>

        <div class="qna">
          <h2>What are the projected rates of insurance for 2021?</h2>
          <a href="#">Category Name</a>
        </div>

        <div class="qna">
          <h2>What is D&O Liability?</h2>
          <a href="#">Category Name</a>
        </div>

        <div class="qna">
          <h2>How Do I know if I have the right coverage for my Property?</h2>
          <a href="#">Category Name</a>
        </div>
      </div>
    </div>

  </div>
</section>
<!-----------------------  expert end ----------------------->


<!-----------------------  coverage start ----------------------->
<section class="coverage">
  <div class="container">
    <div class="coverage-body">
      <div class="row">
        <div class="col-md-6">
          <h3>Better coverage is closer than you think</h3>
        </div>
        <div class="col-md-6 px-5 pt-4">
          <p class="coverage-text coverage-text1">Tell us about your property</p>
          <p class="coverage-text coverage-text2">Get an instant, personalized quote</p>
          <p class="coverage-text coverage-text3">Enjoy up to 50% savings</p>
        </div>
        <div class="col-md-6">
          <p class="text-center mt-md-0 mt-5"><a href="#" class="btn-orange d-block w-50 mx-auto">Get Start</a></p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-----------------------  social start ----------------------->
<div class="social py-5">
  <div class="container-fluid">
    <img src="/assets/image/Vector.svg" class="d-lg-block d-none mx-auto" alt="Logo" />
    <img src="/assets/Coverage/image/logo.svg" class="d-lg-none d-block mx-auto" alt="Logo">
  </div>
  <p class="social-links text-center d-lg-none d-block mt-4">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
  <nav>
    <div class="container-fluid my-5">
      <p class="text-center">
        <a routerLink="/coverage">Coverage</a>
        <a routerLink="/learningCenter">Learning Center</a>
        <a routerLink="/expertAsk">Ask The Expert</a>
        <a routerLink="/about">About</a>
      </p>
    </div>
  </nav>

  <p class="social-links text-center d-lg-block d-none">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
</div>
<!-----------------------  social end ----------------------->
<!------------------------- footer start ------------------------------>
<footer>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <p class="text-lg-left d-lg-block d-none text-center"> &#169; 2020 Honeycomb Insurance. All rights reserved.</p>
        <p class="text-lg-left d-lg-none d-block text-center"> &#169; © 2020 Acme. All right reserved.</p>
      </div>
      <div class="col-lg-6">
        <p class="text-lg-right text-center">
          <a href="#" class="d-lg-inline d-block">Privacy Policy</a>
          <a href="#" class="d-lg-inline d-block my-4">Terms of Service</a>
        </p>
      </div>
    </div>
  </div>
</footer>
<!------------------------- footer end ------------------------------>
